module.exports = __webpack_public_path__ + "static/media/kv-ja.0d39de89.jpg";